{/*import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SocialIcons from "./SocialIcons";
import axios from "axios";
import api from '../api.js';

export default function Signin(){
  const navigate = useNavigate();
  const [email,setEmail] = useState('');
  const [password,setPassword] = useState('');
   const [remember,setRemember] = useState(false);

   const primaryColor = '#3b49ff'; // matches sign-in button tone (adjust if needed)


  const handleSignin = async (e) => {
  e.preventDefault();
  try {
    const res = await api.post("/auth/login", { email, password });
    // response shape: { access_token, refresh_token, token_type }
    localStorage.setItem("access_token", res.data.access_token);
    localStorage.setItem("refresh_token", res.data.refresh_token);
    if (remember) {
      localStorage.setItem("rememberedEmail", email);
    } else {
      localStorage.removeItem("rememberedEmail");
    }
    navigate("/product-selector");
  } catch (err) {
    alert(err.response?.data?.detail || "Login failed");
  }
};
  // before intergration code 
  {/*const handleSignin = async (e) => {
    e.preventDefault();
    try{
      // replace with your backend login endpoint
      // const res = await axios.post('http://localhost:8000/auth/login', { email, password });
      // localStorage.setItem('token', res.data.access_token);
      // mock:
      localStorage.setItem('token', 'demo-token');
       if(remember){
        localStorage.setItem('rememberedEmail', email);
      } else {
        localStorage.removeItem('rememberedEmail');
      }
      navigate('/product-selector');
    }catch(err){
      alert(err.response?.data?.detail || 'Login failed');
    }
  };

  return (
    <div className="auth-container">
      <h2>Sign In</h2>
      <form onSubmit={handleSignin}>
        <div className="input-wrap">
          <input type="email" placeholder="Email" value={email}
            onChange={(e)=>setEmail(e.target.value)} required />
        </div>
        <div className="input-wrap">
          <input type="password" placeholder="Password" value={password}
            onChange={(e)=>setPassword(e.target.value)} required />
        </div>
          <div className="form-row">
          <label className="remember">
            <input
              type="checkbox"
              checked={remember}
              onChange={(e)=>setRemember(e.target.checked)}
            />
            <span>Keep me Login</span>
          </label>

          <Link to="/forgot-password" className="forgot-password">Forgot Password?</Link>
        </div>

        <button className="primary blue" type="submit">Sign In</button>
      </form>

      <Link to="/forgot-password" className="forgot-password">Forgot Password?</Link> 

      <SocialIcons />

      <p className="switch-line">Don't have an account? <Link to="/signup">Sign Up</Link></p>
    </div>
  );
}*/}
// added this code 31-10-2025
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SocialIcons from "./SocialIcons";
import axios from "axios";
import api from '../api.js';

export default function Signin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);

  const primaryColor = '#3b82ff'; // matches sign-in button tone (adjust if needed)
  //change the signin for integrate with stride_Next
  const handleSignin = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post("/auth/login", { email, password });

      const accessToken = res.data.access_token;
      const refreshToken = res.data.refresh_token;



      // Store tokens
      localStorage.setItem("access_token", accessToken);
      localStorage.setItem("refresh_token", refreshToken);

      // Remember email checkbox
      if (remember) {
        localStorage.setItem("rememberedEmail", email);
      } else {
        localStorage.removeItem("rememberedEmail");
      }

      window.location.href =
        "https://stridenext.in/auth/callback?token=" + res.data.access_token;



    } catch (err) {
      alert(err.response?.data?.detail || "Login failed");
    }
  };

  {/*const handleSignin = async (e) => {
  e.preventDefault();
  try {
    const res = await api.post("/auth/login", { email, password });
    localStorage.setItem("access_token", res.data.access_token);
    localStorage.setItem("refresh_token", res.data.refresh_token);
 
    if (remember) {
      localStorage.setItem("rememberedEmail", email);
    } else {
      localStorage.removeItem("rememberedEmail");
    }
 
    // ✅ Redirect logic
    const redirectUrl = new URLSearchParams(window.location.search).get("redirect");
    window.location.href = redirectUrl || "http://localhost:3000/login";
  } catch (err) {
    alert(err.response?.data?.detail || "Login failed");
  }
};
const handleSignin = async (e) => {
  e.preventDefault();
  try {
    const res = await api.post("/auth/login", { email, password });
    // response shape: { access_token, refresh_token, token_type }
    localStorage.setItem("access_token", res.data.access_token);
    localStorage.setItem("refresh_token", res.data.refresh_token);
    if (remember) {
      localStorage.setItem("rememberedEmail", email);
    } else {
      localStorage.removeItem("rememberedEmail");
    }
    //navigate("/product-selector");
    // after successful login
const redirectUrl = new URLSearchParams(window.location.search).get("redirect");
if (redirectUrl) {
  window.location.href = redirectUrl || "http://localhost:3000/"; // go back to StrideNext or other app
} else {
  navigate("/product-selector");
}
  } catch (err) {
    alert(err.response?.data?.detail || "Login failed");
  }
};/*}

  // before intergration code 
  {/*const handleSignin = async (e) => {
    e.preventDefault();
    try{
      // replace with your backend login endpoint
      // const res = await axios.post('http://localhost:8000/auth/login', { email, password });
      // localStorage.setItem('token', res.data.access_token);
      // mock:
      localStorage.setItem('token', 'demo-token');
       if(remember){
        localStorage.setItem('rememberedEmail', email);
      } else {
        localStorage.removeItem('rememberedEmail');
      }
      navigate('/product-selector');
    }catch(err){
      alert(err.response?.data?.detail || 'Login failed');
    }
  };*/}

  return (
    <div className="auth-container">
      <h2>Sign In</h2>
      <form onSubmit={handleSignin}>
        <div className="input-wrap">
          <input type="email" placeholder="Email" value={email}
            onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div className="input-wrap">
          <input type="password" placeholder="Password" value={password}
            onChange={(e) => setPassword(e.target.value)} required />
        </div>
        <div className="form-row">
          <label className="remember">
            <input
              type="checkbox"
              checked={remember}
              onChange={(e) => setRemember(e.target.checked)}
            />
            <span>Keep me Login</span>
          </label>

          <Link to="/forgot-password" className="forgot-password">Forgot Password?</Link>
        </div>

        <button className="primary blue" type="submit">Sign In</button>
      </form>

      {/*<Link to="/forgot-password" className="forgot-password">Forgot Password?</Link>*/}

      <SocialIcons />

      <p className="switch-line">Don't have an account? <Link to="/signup">Sign Up</Link></p>
    </div>
  );
}

